import { render } from "./CriteriaTitle005.vue?vue&type=template&id=52f35508&scoped=true"
import script from "./CriteriaTitle005.vue?vue&type=script&lang=js"
export * from "./CriteriaTitle005.vue?vue&type=script&lang=js"

import "./CriteriaTitle005.vue?vue&type=style&index=0&id=52f35508&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52f35508"]])

export default __exports__